import { render, staticRenderFns } from "./GreenAccomodationForm.vue?vue&type=template&id=30acca9e&scoped=true&"
import script from "./GreenAccomodationForm.vue?vue&type=script&lang=js&"
export * from "./GreenAccomodationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30acca9e",
  null
  
)

export default component.exports